<template>
  <div>
    <!-- 整个单子售后 -->
    <el-dialog :title="$t('message.afterTheWholeOrder')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1248px" center>
      <div class="content">
        <!-- 原因填写-->
        <div class="cause">
          <!-- 左边向 -->
          <div class="cause-item">
            <!-- 客户 -->
            <div class="row">
              <div class="label">{{ $t("message.user") }}:</div>
              <div class="val">{{ detail.user ? detail.user.realname : '' }}（{{ detail.user ? detail.user.id : '' }}）
              </div>
            </div>
            <!-- 配送单汇率 -->
            <div class="row">
              <div class="label">{{ $t("message.deliveryRate") }}:</div>
              <div class="val">{{ detail.exchange_rate }}（円/元）</div>
            </div>
            <!-- 问题物流号 -->
            <div class="row">
              <div class="label">
                {{ $t("message.problemLogisticsNumber") }}:
              </div>
              <div class="val">
                <el-select v-model="datas.express_no" placeholder="请选择">
                  <el-option v-for="item in problemLogistics" :key="item.express_no" :label="item.express_no"
                    :value="item.express_no">
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 售后原因选择 -->
            <div class="row">
              <div class="label">
                {{ $t("message.afterSaleReasonSelection") }}:
              </div>
              <div class="val">
                <el-select v-model="datas.reason_type" placeholder="请选择">
                  <el-option v-for="item in cause" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 客户反馈问题 -->
            <div class="row">
              <div class="label">
                {{ $t("message.customerFeedbackProblem") }}:
              </div>
              <div class="val">
                <el-input type="textarea" placeholder="请输入内容" v-model="datas.client_desc" resize="none">
                </el-input>
              </div>
            </div>
          </div>
          <!-- 右边向 -->
          <div class="cause-item">
            <!-- 客户界面是否显示 -->
            <div class="row">
              <div class="label">
                {{ $t("message.whetherTheCustomerInterfaceDisplays") }}:
              </div>
              <div class="val">
                <el-radio v-model="datas.is_client_show" :label="1">显示</el-radio>
                <el-radio v-model="datas.is_client_show" :label="0">不显示</el-radio>
              </div>
            </div>
            <!-- 问题截图添加 -->
            <div class="row">
              <div class="label">{{ $t("message.problemScreenshotAdd") }}:</div>
              <div class="val client_images">
                <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card"
                  :file-list="client_images" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                  :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
            <!-- 业务售后处理意见 -->
            <div class="row">
              <div class="label">
                {{ $t("message.adviceOnAfterSaleHandlingOfBusiness") }}:
              </div>
              <div class="val">
                <el-input type="textarea" placeholder="请输入内容" v-model="datas.admin_desc" resize="none">
                </el-input>
              </div>
            </div>
            <!-- 出入金名义 -->
            <div class="row">
              <div class="label">
                {{ $t("message.depositName") }}（客户查看）:
              </div>
              <div class="val">
                <el-input type="textarea" placeholder="请输入内容" v-model="datas.client_bill_reason" resize="none">
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="table">
          <!-- 售后费用调整明细： -->
          <h6>
            {{ $t("message.afterSaleExpenseAdjustmentDetails") }}
            <el-button type="success" size="small" class="fr" @click="add">
              {{ $t("message.add") }}
            </el-button>
          </h6>
          <ol>
            <li class="flex05">NO</li>
            <!-- 费用调整名义 -->
            <li>{{ $t("message.nominalCostAdjustment") }}</li>
            <!-- 备注说明 -->
            <li>{{ $t("message.remarks") }}</li>
            <!-- 赔款金额（円） -->
            <li>{{ $t("message.amountOfIndemnityYen") }}</li>
            <!-- 收费金额（円） -->
            <li>{{ $t("message.amountCharged") }}</li>
            <!-- 操作 -->
            <li class="flex05">{{ $t("message.operation") }}</li>
          </ol>
          <ul v-for="(item, index) in fee_list" :key="index">
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 费用调整名义 -->
            <li>
              <el-select v-model="item.fee_type" placeholder="请选择">
                <el-option v-for="item in mingyi" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </li>
            <!-- 备注说明 -->
            <li>
              <el-input type="textarea" placeholder="请输入内容" v-model="item.remark" resize="none">
              </el-input>
            </li>
            <!-- 赔款金额（円） -->
            <li>
              <el-input v-model="item.z" @input="totalAmount" type="number" :disabled="item.f != ''"></el-input>
            </li>
            <!-- 收费金额（円） -->
            <li>
              <el-input v-model="item.f" @input="totalAmount" type="number" :disabled="item.z != ''"></el-input>
            </li>
            <!-- 操作 -->
            <li class="flex05">
              <el-button type="success" size="small" @click="del(index)" class="dark">{{ $t("message.delete")
                }}</el-button>
            </li>
          </ul>
          <!-- 统计 -->
          <div class="total">
            <!-- 合计调整 -->
            <span>{{ $t("message.aggregateAdjustment") }}：{{ total }}円</span>
          </div>
        </div>
        <!-- 售后处理确认过程截图： -->
        <div class="cause">
          <div class="cause-item">
            <!-- 售后处理确认过程截图： -->
            <div class="row">
              <div class="label" style="flex: 2">
                {{ $t("message.screenshotOfAfterSalesProcessConfirmatio") }}:
              </div>
              <div class="val client_images">
                <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card"
                  :file-list="admin_images" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveY"
                  :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccessY">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="cause-item"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 确认提出 -->
        <el-button type="primary" @click="checkRepeatAfterSale">
          {{ $t("message.confirmAndPropose") }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      detail: {},
      dialogVisible: false,
      cause: [], //原因
      mingyi: [], //名义
      datas: {},
      total: 0,
      client_images: [],
      admin_images: [],
      fee_list: [],
      dialogImageUrl: "",
      imgDialogVisible: false,
    };
  },
  computed: {
    ...mapState({
      problemLogistics: (state) => state.porderDetail.problemLogistics,
    }),
  },
  methods: {
    // 售后- 提出校验是否有重复金额的记录
    checkRepeatAfterSale() {
      let datas = {
        porder_sn: this.detail.porder_sn,
        amount: this.total
      }
      this.$api.capitalApi.checkRepeatAfterSale(datas).then((res) => {
        if (res.data.is_repeat) {
          this.$alert(`${res.data.desc}`, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            center: true,
            callback: action => {
              if (action == 'confirm') {
                this.porderWholeStore()
              }
            }
          });
        } else {
          this.porderWholeStore()
        }

      })
    },
    // 售后-整单-提出
    porderWholeStore() {
      if (this.client_images != false) {
        this.client_images.forEach((item) => {
          this.datas.client_images.push(item.response.data);
        });
      }
      if (this.admin_images != false) {
        this.admin_images.forEach((item) => {
          this.datas.admin_images.push(item.response.data);
        });
      }
      if (this.fee_list != false) {
        this.datas.fee_list = this.fee_list;
      }

      if (!this.datas.client_bill_reason) return this.$message.error('入金名义（客户查看）,不能为空')
      this.$api.capitalApi.porderWholeStore(this.datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$router.push('/afterSale')
      });
    },
    // 客户
    handleRemove(file, fileList) {
      this.client_images = fileList;
    },
    handleAvatarSuccess(res, file, fileList) {
      this.client_images = fileList;
    },
    //业务员
    handleRemoveY(file, fileList) {
      this.admin_images = fileList;
    },
    handleAvatarSuccessY(res, file, fileList) {
      this.admin_images = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    //新增费用调整明细
    add() {
      this.fee_list.push({
        fee_type: "",
        amount: "",
        remark: "",
        z: "", //正
        f: "", //负
      });
    },
    //删除
    del(i) {
      this.fee_list.splice(i, 1);
    },
    //合计调整
    totalAmount() {
      this.total = 0;
      this.fee_list.forEach((item) => {
        if (item.z) {
          this.total += item.z - item.f - 0;
          item.amount = item.z - 0;
        } else {
          this.total -= item.f;
          item.amount = -item.f - 0;
        }
      });
      console.log(this.fee_list);
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        // 原因
        this.$api.capitalApi.configReasonList().then((res) => {
          this.cause = res.data;
        });
        // 名义
        this.$api.capitalApi.configFeeTypeList().then((res) => {
          this.mingyi = res.data;
        });
        // 预览数据
        this.$api.capitalApi
          .porderWholePreview({ porder_sn: this.$route.query.porder_sn })
          .then((res) => {
            this.detail = res.data;
            this.datas = {
              after_sale_sn: res.data.after_sale_sn,
              porder_sn: res.data.porder_sn,
              express_no: "",
              is_client_show: 1,
              reason_type: "",
              client_desc: "",
              client_images: [],
              admin_desc: "",
              admin_images: [],
              fee_list: [],
            };
          });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .cause {
    display: flex;

    .cause-item {
      flex: 1;

      .row {
        display: flex;
        margin-bottom: 16px;
        line-height: 40px;

        .label {
          line-height: 40px;
          flex: 1.4;
          font-size: 16px;
        }

        .val {
          flex: 3;

          /deep/.el-textarea__inner {
            height: 120px;
          }
        }

        .client_images {
          height: 95px;
          overflow: hidden;
        }
      }

      &:nth-last-child(1) {
        margin-left: 85px;
      }
    }
  }

  .table {
    h6 {
      margin-bottom: 20px;
      font-size: 16px;
    }

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      li {
        padding: 24px 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .total {
      margin: 20px 0;
      padding-left: 650px;
      font-size: 16px;
      font-weight: 600;
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}

/deep/.el-upload {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

/deep/.el-upload-list__item {
  width: 80px;
  height: 80px;

  img {
    width: 80px;
    height: 80px;
  }
}
</style>